import React, {useState} from 'react';
import { Button } from 'reactstrap';
import styled from 'styled-components';
import isPropValid from '@emotion/is-prop-valid';
import { ThinkingTalentsReportUserItem } from './thinking-talents-report-user-item';
import { ModalReportTT } from '../../pages/home/thinkingTalents/ModalReportTT';
import { useSelector } from 'react-redux';

const StyledQuadrant = styled('div').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop) && prop !== 'quadrant_color',
  })`
  border: ${props => "2px solid " + props.quadrant_color};
  .quadrant-name {
    color: ${props => props.quadrant_color};
  }
`;

export const QuadrantItem = ({ talent, user}) => {
    const questions = useSelector(state => state.questions);
    const [modal, setModal] = useState(false);
    const [current_item, setCurrentItem] = useState(null);

    const toggle = () => {
        setModal(!modal);
        const current_item = questions.quadrants.find(item => item.id === talent.quadrant.id);
        setCurrentItem(current_item);
    }

    return (
        <>
        <StyledQuadrant quadrant_color={talent.quadrant.color} className={`p-lg-3 rounded border-${talent.quadrant.name.toLowerCase()}`}>
            <div className='d-lg-none'>
                <Button onClick={toggle} color='link' className='d-block w-100 text-decoration-none text-body'>
                    <h3 className="h5 mb-0 quadrant-name mb-2">{talent.quadrant.name === 'All' ? 'Talents In All Quadrants' : talent.quadrant.name}</h3>
                    <p className='mb-1'><span className='libre-caslon-text-bold h4'>{talent.quadrant.items.length}</span><br/>Talents</p>
                    <p className='text-muted mb-0'><small><i>Tap to view more</i></small></p>
                </Button>
            </div>
            <div className='d-lg-block d-none'>
                <div className='text-center mb-3'>
                    <h3 className="h4 mb-0 quadrant-name">{talent.quadrant.name === 'All' ? 'Talents In All Quadrants' : talent.quadrant.name}</h3>
                    <p className='small text-muted'>
                        {talent.quadrant.excerpt} <Button color="link" className="p-0 border-0 d-inline-block text-danger font-weight-medium" onClick={toggle}>View more</Button>
                    </p>
                </div>
                <div className="d-flex flex-wrap justify-content-around row-cols-3 row-cols-md-4">
                    {talent.quadrant.items.map(item => 
                        <ThinkingTalentsReportUserItem item={item} color={talent.quadrant.color} key={item.item.id}/>
                    )}
                </div>
            </div>
        </StyledQuadrant>

        <ModalReportTT modal={modal} toggle={toggle} current_item={current_item} user={user}/>

        </>
    )
}
